
import { Button, Form, Input, InputNumber, Select, Space, Spin } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
import { getFormItemLabelNode } from '../../utils/formLabel';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const OtpPropsDefaults = {
    label: '',
    name: '',
    placeholder: '',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    showPreFix: false,
    isFormItem: true,
    disabled: false
};

export const FormOtp = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var _m, _n, _o, _p, _q, _r, _s;
    var inputStyle = {
        width: '100%',
        borderRadius: getBorderRadiusValue((_m = style === null || style === void 0 ? void 0 : style.inputBorderRadius) !== null && _m !== void 0 ? _m : undefined),
        fontSize: (_n = style === null || style === void 0 ? void 0 : style?.inputFontSize) !== null && _n !== void 0 ? (isMobile ? _n/1.1 : _n) : undefined,
        color: (_o = style === null || style === void 0 ? void 0 : style.inputColor) !== null && _o !== void 0 ? _o : undefined,
        backgroundColor: (_p = style === null || style === void 0 ? void 0 : style.inputBackgroundColor) !== null && _p !== void 0 ? _p : undefined,
        borderColor: (_q = style === null || style === void 0 ? void 0 : style.inputBorderColor) !== null && _q !== void 0 ? _q : undefined,
        borderWidth: (_r = style === null || style === void 0 ? void 0 : style.inputBorderWidth) !== null && _r !== void 0 ? _r : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.inputPadding, isMobile),
    }
    var buttonStyle = _a.buttonStyle;
    var btnStyle = {
        fontSize: buttonStyle === null || buttonStyle === void 0 ? undefined : (isMobile ? buttonStyle.buttonFontSize/1.1 : buttonStyle.buttonFontSize),
        fontWeight: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonFontWeight,
        color: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonColor,
        backgroundColor: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonBackgroundColor,
        borderColor: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonBorderColor,
        borderWidth: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonBorderWidth,
        borderRadius: getBorderRadiusValue(buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonBorderRadius),
        padding: globalGetPadding(buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.buttonPadding, isMobile),
    }
    var btnOkStyle = {
        fontSize: buttonStyle === null || buttonStyle === void 0 ? undefined : (isMobile ? buttonStyle.btnOkFontSize/1.1 : buttonStyle.btnOkFontSize),
        fontWeight: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.btnOkFontWeight,
        color: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.btnOkColor,
    }
    var btnErrorStyle = {
        fontSize: buttonStyle === null || buttonStyle === void 0 ? undefined : (isMobile ? buttonStyle.btnErrorFontSize/1.1 : buttonStyle.btnErrorFontSize),
        fontWeight: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.btnErrorFontWeight,
        color: buttonStyle === null || buttonStyle === void 0 ? undefined : buttonStyle.btnErrorColor,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : OtpPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : OtpPropsDefaults.name;
    var placeholder = (_i = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _i !== void 0 ? _i : OtpPropsDefaults.placeholder;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : OtpPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : OtpPropsDefaults.visible;
    var disabled = (_s = props === null || props === void 0 ? void 0 : props.disabled) !== null && _s !== void 0 ? _s : OtpPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    
    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;

    var messageProps = _a.messageProps;
    const buttonLabel = messageProps?.buttonLabel !== null && messageProps?.buttonLabel !== void 0 ? messageProps?.buttonLabel : '';
    const countdownLabel = messageProps?.countdownLabel !== null && messageProps?.countdownLabel !== void 0 ? messageProps?.countdownLabel : '';
    const otpErrorLabel = messageProps?.otpErrorLabel !== null && messageProps?.otpErrorLabel !== void 0 ? messageProps?.otpErrorLabel : '';
    const otpValidLabel = messageProps?.otpValidLabel !== null && messageProps?.otpValidLabel !== void 0 ? messageProps?.otpValidLabel : '';

    const validateOtpResult = useMemo(()=>{
        const res = _a?.validateOtpResult?.find(item=>item.field === name);
        return res?.res;
    }, [_a?.validateOtpResult, name])

    const otpLoading = useMemo(()=>{
        const res = _a?.otpLoading?.find(item=>item.field === name);
        return res?.loading;
    }, [_a?.otpLoading, name])

    const isLoading = useMemo(()=>{
        const res = _a?.validateOtpLoading?.find(item=>item.field === name);
        return res?.loading;
    }, [_a?.validateOtpLoading, name])

    const canSendOtp = useMemo(()=>{
        const res = _a?.canSendOtp?.find(item=>item.field === name);
        return res?.canSend;
    }, [_a?.canSendOtp, name])

    const waitOtpSeconds = useMemo(()=>{
        const res = _a?.waitOtpSeconds?.find(item=>item.field === name);
        return res?.countdown;
    }, [_a?.waitOtpSeconds, name])

    const handleStartSendOtp = useCallback(()=>{
        if(_a?.handleStartSendOtp) {
            _a?.handleStartSendOtp(name)
        }
    }, [_a, name]);

    const handleOnChange = useCallback((val)=>{
        if(_a?.handleChangeOTP) {
            _a.handleChangeOTP(val, name);
        }
        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
            ...prevData,
            [name]: {
                value: val.target.value,
                isRequired: prevData[name]?.isRequired,
                type: prevData[name]?.type
            }
        }))
    }, [_a, name])
        
    const [fieldHidden, setFieldHidden] = useState(false);
            
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //hiddenOnly字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    const formItemLabel = getFormItemLabelNode(label, required, labelStyle, item_layout === 'vertical' && item_colon);
    return !calVisible && !fieldHidden ? null : 
        <Spin spinning={isLoading}><div style={{...wStyle, ...fieldHidden ? {
            visibility: 'hidden',
            opacity: 0,
            height: 0,
            overflow: 'hidden',
            padding: 0,
            margin: 0,
            border: 0
        } : {}}}>
            <Form.Item
                name={name}
                label={formItemLabel}
                className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                    'ant-form-item-label-right' : ''}
                layout={item_layout}
                colon={item_colon}
                rules={required ? [{ required: true, message: requiredText}] : []}
            >
                <Input
                    placeholder={placeholder} 
                    style={inputStyle}
                    disabled={disabled}
                    suffix={
                    <Space>
                        {
                            validateOtpResult === true ? <div style={{
                                ...btnOkStyle,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                            }}>
                                <svg t="1743643931130" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2627" width="16" height="16"><path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z" fill={btnOkStyle?.color} p-id="2628"></path></svg>
                                {otpValidLabel}
                            </div> : validateOtpResult === false ? <div style={{
                                ...btnErrorStyle,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                            }}>
                                <svg t="1743643969439" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3840" width="16" height="16"><path d="M512 981.333333C252.8 981.333333 42.666667 771.2 42.666667 512S252.8 42.666667 512 42.666667s469.333333 210.133333 469.333333 469.333333-210.133333 469.333333-469.333333 469.333333z m44.245333-469.333333l159.914667-159.914667a31.274667 31.274667 0 1 0-44.245333-44.245333L512 467.754667 352.085333 307.84a31.274667 31.274667 0 1 0-44.245333 44.245333L467.754667 512l-159.914667 159.914667a31.274667 31.274667 0 1 0 44.245333 44.245333L512 556.245333l159.914667 159.914667a31.274667 31.274667 0 1 0 44.245333-44.245333L556.245333 512z" fill={btnErrorStyle?.color} p-id="3841"></path></svg>
                                {otpErrorLabel}
                            </div> : null
                        }
                        <Button style={btnStyle} onClick={handleStartSendOtp}
                            loading={otpLoading}
                            disabled={!canSendOtp || validateOtpResult === true}
                        >
                            {
                                waitOtpSeconds ? `(${countdownLabel.replace('{{ .waitOtpSeconds }}', waitOtpSeconds)}` : buttonLabel
                            }
                        </Button>
                    </Space>
                    }
                    onChange={handleOnChange}
                />
            </Form.Item>
        </div></Spin>
}

